import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Container, TextField, Typography, Alert, Paper } from '@mui/material';
import { resetPassword } from '../services/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!newPassword || newPassword.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (!token) {
      setError('Invalid reset link. Please request a new one.');
      return;
    }

    try {
      const response = await resetPassword(token, newPassword);
      setSuccess(response.data.message || 'Password reset successfully!');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data || 'Failed to reset password. The link may have expired.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Paper sx={{ p: 4, width: '100%' }}>
          <Typography variant="h4" align="center" gutterBottom>
            Reset Password
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ mb: 3 }}>
            Enter your new password below.
          </Typography>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}

          {!success && (
            <Box component="form" onSubmit={handleSubmit}>
              <TextField
                fullWidth label="New Password" type="password" margin="normal" required
                value={newPassword} onChange={(e) => setNewPassword(e.target.value)}
                helperText="Minimum 6 characters"
              />
              <TextField
                fullWidth label="Confirm Password" type="password" margin="normal" required
                value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
                error={confirmPassword.length > 0 && newPassword !== confirmPassword}
                helperText={confirmPassword.length > 0 && newPassword !== confirmPassword ? 'Passwords do not match' : ''}
              />
              <Button type="submit" fullWidth variant="contained" sx={{ mt: 2 }}>
                Update Password
              </Button>
            </Box>
          )}

          {success && (
            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              Redirecting to login page...
            </Typography>
          )}
        </Paper>
      </Box>
    </Container>
  );
}
